export default () => {
    const existingTag = document.getElementById("youtube-api");
    if (existingTag) {
        return;
    }
    const tag = document.createElement('script');
    tag.id = "youtube-api"

    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode!.insertBefore(tag, firstScriptTag);
}
